import { useMemo } from "react";

import { useCoverForContext } from "../../provider/cover-for.provider";
import { getSingleOptionItem } from "../../utils/cover-for-utils";

function useFormSectionHook() {
  const {
    selectedAnswer,
    groupedCmsData,
    setSelectedAnswer,
    setIsFamilyModalOpen,
  } = useCoverForContext();

  const toggleButtonOptions = useMemo(
    () => [
      getSingleOptionItem("INDIVIDUAL", groupedCmsData, selectedAnswer),
      getSingleOptionItem("COUPLE", groupedCmsData, selectedAnswer),
      getSingleOptionItem("FAMILY", groupedCmsData, selectedAnswer),
      getSingleOptionItem("OTHER", groupedCmsData, selectedAnswer),
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedAnswer]
  );

  function handleOptionSelect(id: typeof selectedAnswer) {
    if (
      id === selectedAnswer ||
      (id === "FAMILY" && selectedAnswer === "SINGLE_PARENT_FAMILY")
    ) {
      setSelectedAnswer("DEFAULT");
      return;
    }

    if (id === "FAMILY") {
      setIsFamilyModalOpen(true);
      return;
    }

    setSelectedAnswer(id);
  }

  return {
    toggleButtonOptions,
    handleOptionSelect,
  };
}

export default useFormSectionHook;
